/**
 * Internal Dependencies
 */
const metadata = {
  name: "group",
  supports: {
    innerBlocks: true,
    editable: false,
    required: false,
    attachment: true,
    description: true,
    logic: true,
    logicConditions: false,
    theme: true
  },
  attributes: {}
};
const {
  name
} = metadata;
export { name, metadata };
//# sourceMappingURL=index.js.map